import * as React from "react";
import SelectEmailModalForm from "../../Forms/buypermits/SelectEmailModalForm";
import BaseModal, { BaseModalContent } from "../BaseModal";

const SelectEmailModal=(props)=>{ 
   const {isOpenSelectEmailModal,CloseSelectEmailModal,handleOpenAddEmailModal} = props;

//    useEffect(() => {
//     const ActiveData = emailData && emailData.filter((items) => {
//       return items.inactive === false
//     })
//     setMyEmailData(ActiveData)
//     dispatch(getCheckoutSelectEmailStates({accountId:1337}));
//   }, [emailData])

   
    return(
        <>
            <BaseModal
                title="Select Email"
                align="center"
                open={isOpenSelectEmailModal}
                onClose={CloseSelectEmailModal}
                with={500}                
            >
                <BaseModalContent>
                   <SelectEmailModalForm 
                      CloseSelectEmailModal={CloseSelectEmailModal}
                      handleOpenAddEmailModal={handleOpenAddEmailModal}
                   />
                </BaseModalContent>
            </BaseModal>
        </>
    )
}
export default SelectEmailModal;